export const namespace = 'canalplus.block.oneshop.propal.selection';
export { PropalSelection as Component } from './components/PropalSelection';
export { default as propsFormatter } from './propsFormatter';
